import { render, staticRenderFns } from "./layout-view.vue?vue&type=template&id=3928583b&scoped=true"
import script from "./layout-view.vue?vue&type=script&lang=js"
export * from "./layout-view.vue?vue&type=script&lang=js"
import style0 from "./layout-view.vue?vue&type=style&index=0&id=3928583b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_50f6069bc14464b8bd79aa1c8f71d64f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3928583b",
  null
  
)

export default component.exports